import { convertValueInCr, convertValueInL, convertValueInThousands, roundDecimalValueUptoTwo } from "utils/roundDecimalValue";

export const tableRowTypes = {
	SALE: { name: "SALE(L)", key: "SALE", valueGetter: (val) => convertValueInL(val), tooltipValueGetter: (val) => convertValueInL(val, "string") },
	SALE_CONTRI_PERCENT: { name: "SALE CONT(%)", key: "SALE_CONTRI_PERCENT", valueGetter: (val) => roundDecimalValueUptoTwo(val), tooltipValueGetter: (val) => `${roundDecimalValueUptoTwo(val)}%` },
	DISCOUNT_PERCENT: { name: "DISC(%)", key: "DISCOUNT_PERCENT", valueGetter: (val) => roundDecimalValueUptoTwo(val), tooltipValueGetter: (val) => `${roundDecimalValueUptoTwo(val)}%` },
	UNITS: { name: "UNITS(K)", key: "UNITS", valueGetter: (val) => convertValueInThousands(val), tooltipValueGetter: (val) => convertValueInThousands(val, "string") },
	ASP: { name: "ASP", key: "ASP", valueGetter: (val) => roundDecimalValueUptoTwo(val), tooltipValueGetter: (val) => convertValueInThousands(val, "string") },
	GP_VALUE: { name: "GP VAL(L)", key: "GP_VALUE", valueGetter: (val) => convertValueInL(val), tooltipValueGetter: (val) => convertValueInL(val, "string") },
	GP_PERCENT: { name: "GP%", key: "GP_PERCENT", valueGetter: (val) => roundDecimalValueUptoTwo(val), tooltipValueGetter: (val) => `${roundDecimalValueUptoTwo(val)}%` },
	GP_CONTRI_PERCENT: { name: "GP CONTRI%", key: "GP_CONTRI_PERCENT", valueGetter: (val) => roundDecimalValueUptoTwo(val), tooltipValueGetter: (val) => `${roundDecimalValueUptoTwo(val)}%` },
	AOV: { name: "AOV", key: "AOV", valueGetter: (val) =>roundDecimalValueUptoTwo(val), tooltipValueGetter: (val) => convertValueInThousands(val, "string") },
	UPT: { name: "UPT", key: "UPT", valueGetter: (val) => roundDecimalValueUptoTwo(val), tooltipValueGetter: (val) => `${roundDecimalValueUptoTwo(val)}` },
	ROS: { name: "ROS", key: "ROS", valueGetter: (val) => roundDecimalValueUptoTwo(val), tooltipValueGetter: (val) => `${roundDecimalValueUptoTwo(val)}` },
};
export const dummyMetricsData = {
	LY: {
		"2024-10-01": {
			SALE: 546141469.2200003,
			SALE_CONTRI_PERCENT: 6.322875823694036,
			DISCOUNT_PERCENT: 43.13222128810613,
			UNITS: 281314.0,
			ASP: 1941.394559886818,
			GP_VALUE: 346726334.7230006,
			GP_PERCENT: 243.3071769225508,
			GP_CONTRI_PERCENT: 6.402828946884999,
			AOV: 2414.5466126408132,
			UPT: 1.6581864133248074,
			ROS: 973.4048442906575,
		},
		"2024-05-01": {
			SALE: 671353485.6099997,
			SALE_CONTRI_PERCENT: 7.772500281618858,
			DISCOUNT_PERCENT: 35.0241689176642,
			UNITS: 331865.0,
			ASP: 2022.9716469347466,
			GP_VALUE: 442814773.49300104,
			GP_PERCENT: 280.27769948633045,
			GP_CONTRI_PERCENT: 8.177248065378143,
			AOV: 2208.8501128848634,
			UPT: 1.5028118272483635,
			ROS: 1148.3217993079584,
		},
		"2024-02-01": {
			SALE: 506669845.31000006,
			SALE_CONTRI_PERCENT: 5.865898665561501,
			DISCOUNT_PERCENT: 36.83681055012713,
			UNITS: 259200.0,
			ASP: 1954.7447735725311,
			GP_VALUE: 323220690.7230014,
			GP_PERCENT: 247.69418708307796,
			GP_CONTRI_PERCENT: 5.968761491528298,
			AOV: 2424.014071839672,
			UPT: 1.7343455468940978,
			ROS: 896.8858131487889,
		},
		"2024-07-01": {
			SALE: 734665612.4899983,
			SALE_CONTRI_PERCENT: 8.505487500054995,
			DISCOUNT_PERCENT: 44.48403653565473,
			UNITS: 432009.0,
			ASP: 1700.5794149890357,
			GP_VALUE: 439370450.1380033,
			GP_PERCENT: 201.26563497633745,
			GP_CONTRI_PERCENT: 8.113643397744719,
			AOV: 2509.789602657824,
			UPT: 1.893072345803462,
			ROS: 1494.840830449827,
		},
		"2024-03-01": {
			SALE: 703516023.0500003,
			SALE_CONTRI_PERCENT: 8.144857522131051,
			DISCOUNT_PERCENT: 31.82514094023553,
			UNITS: 338035.0,
			ASP: 2081.1928440841934,
			GP_VALUE: 470701608.1550022,
			GP_PERCENT: 295.94623543266874,
			GP_CONTRI_PERCENT: 8.692220867641645,
			AOV: 2628.4139575503077,
			UPT: 1.6110585782174376,
			ROS: 1169.6712802768166,
		},
		"2024-08-01": {
			SALE: 780722835.2699993,
			SALE_CONTRI_PERCENT: 9.038708500170717,
			DISCOUNT_PERCENT: 41.073146541146265,
			UNITS: 442579.0,
			ASP: 1764.0304561897408,
			GP_VALUE: 490319108.89200455,
			GP_PERCENT: 234.06784835535933,
			GP_CONTRI_PERCENT: 9.054487845962644,
			AOV: 2480.666602917484,
			UPT: 1.782699200441136,
			ROS: 1531.4152249134947,
		},
		"2024-06-01": {
			SALE: 744547681.2399998,
			SALE_CONTRI_PERCENT: 8.61989575708903,
			DISCOUNT_PERCENT: 42.85911023257938,
			UNITS: 419430.0,
			ASP: 1775.141695253081,
			GP_VALUE: 458270780.2140029,
			GP_PERCENT: 219.18390809964228,
			GP_CONTRI_PERCENT: 8.462666729396094,
			AOV: 2166.2341688536126,
			UPT: 1.6542581325545551,
			ROS: 1451.3148788927335,
		},
		"2024-09-01": {
			SALE: 658925889.7800008,
			SALE_CONTRI_PERCENT: 7.628621543876482,
			DISCOUNT_PERCENT: 38.8078280864674,
			UNITS: 320980.0,
			ASP: 2052.8565324319297,
			GP_VALUE: 426360126.5180015,
			GP_PERCENT: 261.29469488289925,
			GP_CONTRI_PERCENT: 7.873387990698584,
			AOV: 2501.303518465799,
			UPT: 1.6181680437312171,
			ROS: 1110.6574394463669,
		},
		"2024-04-01": {
			SALE: 744864959.0400006,
			SALE_CONTRI_PERCENT: 8.623568996064792,
			DISCOUNT_PERCENT: 33.576909282391384,
			UNITS: 374788.0,
			ASP: 1987.4301179333397,
			GP_VALUE: 490897095.5380016,
			GP_PERCENT: 278.7402140942668,
			GP_CONTRI_PERCENT: 9.06516124817439,
			AOV: 2506.6799450786148,
			UPT: 1.6701567166683446,
			ROS: 1296.8442906574394,
		},
		"2024-01-01": {
			SALE: 783504204.6199999,
			SALE_CONTRI_PERCENT: 9.070909411493197,
			DISCOUNT_PERCENT: 45.04175693211681,
			UNITS: 407844.0,
			ASP: 1921.0879763340884,
			GP_VALUE: 459641739.0850025,
			GP_PERCENT: 190.66593702811565,
			GP_CONTRI_PERCENT: 8.48798356940837,
			AOV: 2704.667138280759,
			UPT: 1.782994890209581,
			ROS: 1411.2249134948097,
		},
	},
	TY: {
		"2025-03-01": {
			SALE: 840357158.6299999,
			SALE_CONTRI_PERCENT: 9.729116467128103,
			DISCOUNT_PERCENT: 37.12859578484667,
			UNITS: 415220.0,
			ASP: 2023.8841063291745,
			GP_VALUE: 553614948.6210023,
			GP_PERCENT: 278.76170026194836,
			GP_CONTRI_PERCENT: 10.223341764018775,
			AOV: 2385.047449736621,
			UPT: 1.6439177814616344,
			ROS: 1436.7474048442907,
		},
		"2025-04-01": {
			SALE: 832017002.2399998,
			SALE_CONTRI_PERCENT: 9.63255948294693,
			DISCOUNT_PERCENT: 35.03669808911377,
			UNITS: 397816.0,
			ASP: 2091.461887505781,
			GP_VALUE: 551704921.3650023,
			GP_PERCENT: 285.5029794073582,
			GP_CONTRI_PERCENT: 10.188070206656894,
			AOV: 2481.6179169152206,
			UPT: 1.6888182042292101,
			ROS: 1376.5259515570933,
		},
		"2025-10-01": {
			SALE: 502326476.68000185,
			SALE_CONTRI_PERCENT: 5.815613927903272,
			DISCOUNT_PERCENT: 42.76422515734635,
			UNITS: 239528.0,
			ASP: 2097.1513838883216,
			GP_VALUE: 324131924.03260165,
			GP_PERCENT: 256.37666608537336,
			GP_CONTRI_PERCENT: 5.985588800064684,
			AOV: 2703.194243463016,
			UPT: 1.7972336149061574,
			ROS: 828.8166089965398,
		},
		"2025-06-01": {
			SALE: 920715253.6399997,
			SALE_CONTRI_PERCENT: 10.659450977163566,
			DISCOUNT_PERCENT: 45.12090433820208,
			UNITS: 538306.0,
			ASP: 1710.3938162309166,
			GP_VALUE: 562776866.2140028,
			GP_PERCENT: 212.80671617039437,
			GP_CONTRI_PERCENT: 10.392530502509906,
			AOV: 2297.772776173636,
			UPT: 1.798474887657887,
			ROS: 1862.6505190311418,
		},
		"2025-01-01": {
			SALE: 882000134.4400002,
			SALE_CONTRI_PERCENT: 10.211232145601992,
			DISCOUNT_PERCENT: 42.66939155829693,
			UNITS: 433525.0,
			ASP: 2034.4850572400674,
			GP_VALUE: 546249299.9750017,
			GP_PERCENT: 225.51111116198635,
			GP_CONTRI_PERCENT: 10.08732386275127,
			AOV: 2821.0463279705746,
			UPT: 1.8085203164201593,
			ROS: 1500.0865051903115,
		},
		"2025-09-01": {
			SALE: 963282996.0699992,
			SALE_CONTRI_PERCENT: 11.152273010737172,
			DISCOUNT_PERCENT: 46.15251901385331,
			UNITS: 543104.0,
			ASP: 1773.6621274562501,
			GP_VALUE: 586215184.9819998,
			GP_PERCENT: 208.65762990262127,
			GP_CONTRI_PERCENT: 10.82535469509378,
			AOV: 2843.7405784706743,
			UPT: 1.9703359886933058,
			ROS: 1879.2525951557093,
		},
		"2025-07-01": {
			SALE: 1115612076.4600003,
			SALE_CONTRI_PERCENT: 12.915841452113847,
			DISCOUNT_PERCENT: 48.521712099688585,
			UNITS: 713928.0,
			ASP: 1562.639476894029,
			GP_VALUE: 664394178.4680037,
			GP_PERCENT: 196.41503771169698,
			GP_CONTRI_PERCENT: 12.269048676199722,
			AOV: 2893.5750579953738,
			UPT: 2.3827103740113396,
			ROS: 2470.3391003460206,
		},
		"2025-08-01": {
			SALE: 1079638830.3400006,
			SALE_CONTRI_PERCENT: 12.499366269379983,
			DISCOUNT_PERCENT: 44.36546055581043,
			UNITS: 602733.0,
			ASP: 1791.2389571169997,
			GP_VALUE: 657019455.1680031,
			GP_PERCENT: 211.3867071521526,
			GP_CONTRI_PERCENT: 12.132863197648648,
			AOV: 3274.510419277549,
			UPT: 2.3305829371520352,
			ROS: 2085.581314878893,
		},
		"2025-02-01": {
			SALE: 632268180.4999998,
			SALE_CONTRI_PERCENT: 7.319995674900974,
			DISCOUNT_PERCENT: 39.686042165859064,
			UNITS: 319922.0,
			ASP: 1976.319792011802,
			GP_VALUE: 403869708.478001,
			GP_PERCENT: 248.5703162868442,
			GP_CONTRI_PERCENT: 7.458068226282354,
			AOV: 2644.0685514391926,
			UPT: 1.8172094432712431,
			ROS: 1106.9965397923875,
		},
		"2025-05-01": {
			SALE: 869330444.0399994,
			SALE_CONTRI_PERCENT: 10.064550592124162,
			DISCOUNT_PERCENT: 38.40572793625818,
			UNITS: 443384.0,
			ASP: 1960.6716616747544,
			GP_VALUE: 565228847.7020024,
			GP_PERCENT: 265.26517616915675,
			GP_CONTRI_PERCENT: 10.437810068773981,
			AOV: 2606.9303114832246,
			UPT: 1.748292393053395,
			ROS: 1534.2006920415224,
		},
	},
};

export const metricsDataAdapter = (resData) => {
	let dataArr = [];
	Object.keys(resData.TY).forEach((dateKey) => {
		let lyMappedData = {};
		let str = dateKey.split("-");
		str.shift();
		str = str.join("-");
		Object.keys(resData.LY).forEach((date) => {
			let lyDateStr = date.split("-");
			lyDateStr.shift();
			lyDateStr = lyDateStr.join("-");
			if (str === lyDateStr)
				lyMappedData = resData.LY[date]
					? Object.keys(resData.LY[date]).reduce((acc, key) => {
							acc[`LY__${key}`] = resData.LY[date][key];
							return acc;
					  }, {})
					: {};
		});

		dataArr.push({
			...(resData.TY[dateKey]
				? Object.keys(resData.TY[dateKey]).reduce((acc, key) => {
						acc[`TY__${key}`] = resData.TY[dateKey][key];
						return acc;
				  }, {})
				: []),
			...lyMappedData,
			date: dateKey,
		});
	});
	console.log(dataArr, "sdfvshdfdasd");
	return dataArr;
};
